// Import: Middleware Action & Custom Types
import { CLEAN_GET_SALES_DAILY, CLEAN_GET_SALES_DAILY_ERROR } from '_models/redux/types';

// Action function
export const cleanGetSalesDailyAction = () => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    dispatch({
      payload: undefined,
      type: CLEAN_GET_SALES_DAILY,
    });
  } catch (e) {
    dispatch({
      payload: undefined,
      type: CLEAN_GET_SALES_DAILY_ERROR,
    });
  }
};
